import React, { useState } from 'react'
import API_URL from '../common/Apiurl';
import { useNavigate } from "react-router-dom"
import SuccessMessage from '../common/Message';

function Otpverify(){
    const apiUrl = API_URL;
    const [successMessages, setSuccessMessages] = useState([]);
    const [checknumber, setChecknumber] = useState(false);
    const [checklength, setChecklength] = useState(false);
    var getEmail = localStorage.getItem('userEmail');
    const navigate  = useNavigate();
    const postemail = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        const getOTP = data.get('otpValue')
        console.log(getOTP)
        const emailData = {
            "emailId":getEmail,
            "OTP":getOTP
        }
        const sendEmail = await fetch(`${apiUrl}/admin/verifyOtp`,{
            method: 'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(emailData)
        })
        const getData = await sendEmail.json()
        console.log(getData)
        if(getData.status === 200){
            const newSuccessMessage = getData.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
            navigate('/resetpassword')
        }else if(getData.status !== 200){
            const newSuccessMessage = getData.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
    }
    const otpnum = async (e) =>{
        var getValue = e.target.value;
        var checkVal = isNaN(getValue);
        if(checkVal === true){
            setChecknumber(true)    
        }else{
            setChecknumber(false) 
        }
        if(getValue.length > 4){
            setChecklength(true)
            setChecknumber(false) 
        }else{
            setChecklength(false)
        }
    }
    return(
        <>
            <form className="resetForm col-sm-6 mx-auto" onSubmit={postemail}>
                <h1 className="mt-5">Enter Your OTP</h1>
                    <div className="formcontainer">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-5">
                                    <input type="hidden" name="id" value="" />
                                    {/* <label for="text"><strong>OTP</strong></label> */}
                                    <input type="text" name="otpValue" placeholder="OTP" onChange={otpnum} maxLength={4} required/>
                                    {!checknumber?" ":"Please enter only numbers"}
                                    {!checklength?" ":"Please enter only 4 digit"}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-5">
                                <input className="button" type="submit" />
                            </div>
                        </div>                        
                    </div>
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
            </form>
        </>
    )
}

export default Otpverify;